import { styled } from "@mui/material/styles";
import { green } from "@mui/material/colors";

const Container = styled("div")(({ theme }) => ({
  textAlign: "center",
  color: "black",
}));
const ButtonCancel = styled("button")(({ theme }) => ({
  backgroundColor: "#9F9F9F",
  margin: "15px",
  textAlign: "center",
  padding: "5px",
  paddingLeft: "18px",
  paddingRight: "18px",
  borderRadius: "18px",
  border: "0px",
  color: "white",
  "&:hover": {
    backgroundColor: "#D2D1D1",
  },
  "&:focus": {
    outline: "0 !important",
  },
}));
const ButtonUpdate = styled("button")(({ theme }) => ({
  backgroundColor: "#FF0000",
  textAlign: "center",
  margin: "15px",
  padding: "5px",
  paddingLeft: "18px",
  paddingRight: "18px",
  borderRadius: "15px",
  border: "0px",
  color: "white",
  "&:hover": {
    backgroundColor: "#FFCDD2",
    color: "black",
  },
  "&:focus": {
    outline: "0 !important",
  },
}));
export { Container, ButtonCancel, ButtonUpdate };
